import type { RealEstateSearchResult } from "../../types";

/**
 * 不動産検索の結果のピンを作り直すかを決めるキー。結果の物件とその並び（ピンの番号）が同じなら同じ値になる。
 * 件数が同じまま別の結果で検索し直した時に、前の結果のピンが残らないようにするために使う。
 * 住居表示・ポリゴン・タグなど、結果を出した後に書き足す値は含めない（書き足すたびにピンを作り直さないため）
 */
export const getRealEstateSearchPinsKey = (
  results: RealEstateSearchResult[]
): string =>
  results
    .map(
      (r) =>
        `${r.bookType}|${r.prefName}|${r.location}|${r.chibanKaokuNumber}|${r.latitude},${r.longitude}`
    )
    .join("\n");
